// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const AiApplicationInterfaceTypeSchema = z.enum(['HTTP','SSE','WEBSOCKET','MCP','VOICE'] as const);

export type AiApplicationInterfaceTypeType = `${z.infer<typeof AiApplicationInterfaceTypeSchema>}`

export default AiApplicationInterfaceTypeSchema;
